import { useRef, useState } from 'react';
import {
  Alert,
  Pressable,
  StyleSheet,
  Text,
  TextInput,
  View,
  StatusBar
} from 'react-native';
import {User, Mail, Lock} from '../../../assets/icons';
import ScreenWrapper from '../../Components/ScreenWrapper';
import BackButton from '../../Components/BackButton';
import Button from '../../Components/Button';
import Input from '../../Components/Input';
import { hp, wp } from '../../helpers/common';
import { theme } from '../../constants/theme';
import { Supabase } from '../../Utils/supabase.config';
import {NativeStackNavigationProp} from '@react-navigation/native-stack';
import {AuthStackNavigationParms} from './AuthenticationStack';
import { useNavigation } from '@react-navigation/native';
type Props = {
  navigation: NativeStackNavigationProp<AuthStackNavigationParms, 'SignIn'>;
};
const SignIn: React.FC<Props> = ({navigation}) => {
  const navigation1 = useNavigation();
    const emailRef = useRef<string>('');
  const passwordRef = useRef<string>('');
  const [loading, setLoading] = useState<boolean>(false);
 

  const onSubmit = async () => {
    if (!emailRef.current || !passwordRef.current) {
      Alert.alert('Login', 'Please fill all the fields!');
      return;
    }

    const email = emailRef.current.trim();
    const password = passwordRef.current.trim();

    setLoading(true);
    const { error } = await Supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) Alert.alert('Login', error.message);
    setLoading(false);
  };

  return (
    <ScreenWrapper bg={'white'}>
      <StatusBar backgroundColor={'black'} barStyle="light-content"></StatusBar>
      <View style={styles.container}>
        {/* back button */}
        <View>
          <BackButton navigation={navigation1} />
        </View>

        {/* welcome */}
        <View>
          <Text style={styles.welcomeText}>Hey,</Text>
          <Text style={styles.welcomeText}>Welcome Back</Text>
        </View>

        {/* form */}
        <View style={styles.form}>
          <Text style={{ fontSize: hp(1.5), color: theme.colors.text }}>
            Please login to continue
          </Text>
          <Input
            icon={<Mail size={26} strokeWidth={1.6} />}
            placeholder="Enter your email"
            placeholderTextColor={theme.colors.textLight}
            onChangeText={(value: string) => (emailRef.current = value)}
          />
          <Input
            icon={<Lock size={26} strokeWidth={1.6} />}
            secureTextEntry
            placeholder="Enter your password"
            placeholderTextColor={theme.colors.textLight}
            onChangeText={(value: string) => (passwordRef.current = value)}
          />
          <Text style={styles.forgotPassword}>Forgot Password?</Text>

          {/* button */}
          <Button title="Login" loading={loading} onPress={onSubmit} />
        </View>

        <View style={styles.footer}>
          <Text style={styles.footerText}>Don’t have an account?</Text>
          <Pressable onPress={() => navigation.navigate('SignUp')}>
            <Text
              style={[
                styles.footerText,
                {
                  color: theme.colors.primaryDark,
                  fontWeight: '600',
                },
              ]}
            >
              Sign up
            </Text>
          </Pressable>
        </View>
      </View>
    </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 45,
    paddingHorizontal: wp(5),
  },
  welcomeText: {
    fontSize: hp(4),
    fontWeight: '700',
    color: theme.colors.text,
  },
  form: {
    gap: 25,
  },
  forgotPassword: {
    textAlign: 'right',
    fontWeight: '600',
    color: theme.colors.text,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
  },
  footerText: {
    textAlign: 'center',
    color: theme.colors.text,
    fontSize: hp(1.6),
  },
});

export default SignIn;
